import { useEffect, useRef, useState } from "hono/jsx";

export const DeleteAccount = () => {
  const [isOpen, setIsOpen] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <>
      <div class="card bg-base-100 shadow-xl border border-error/50">
        <div class="card-body">
          <h3 class="card-title text-error font-black uppercase tracking-tight">
            Danger Zone
          </h3>
          <p class="text-sm font-medium opacity-70">
            Deleting your account is permanent. This action cannot be undone.
          </p>
          <ul class="list-disc list-inside text-sm font-bold opacity-60 ml-2 space-y-1 mb-4">
            <li>Remove your profile and data</li>
            <li>Release all your reserved rooms immediately</li>
          </ul>

          <div class="card-actions justify-end">
            <button
              type="button"
              onClick={() => setIsOpen(true)}
              class="btn btn-error btn-outline font-black uppercase"
            >
              Delete Account
            </button>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      {isOpen && (
        <div class="fixed inset-0 z-[9999] flex items-center justify-center p-4">
          {/* Backdrop */}
          <div
            class="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity"
            onClick={() => setIsOpen(false)}
          />

          {/* Modal Content */}
          <div class="relative z-10 bg-base-100 border-2 border-error/20 shadow-2xl max-w-sm w-full overflow-hidden rounded-2xl transform transition-all">
            {/* Header */}
            <div class="bg-base-200/50 p-6 border-b border-base-200/50 flex flex-col items-center gap-4 text-center">
              <div class="w-16 h-16 rounded-full bg-error/10 text-error flex items-center justify-center text-3xl mb-2">
                ⚠️
              </div>
              <div>
                <h3 class="font-black text-2xl uppercase tracking-tighter text-error">
                  Delete Account?
                </h3>
                <p class="font-bold opacity-50 text-xs uppercase tracking-widest mt-1">
                  This cannot be undone
                </p>
              </div>
            </div>

            {/* Content */}
            <div class="p-6 text-center space-y-4">
              <p class="text-sm font-medium opacity-70">
                Are you sure you want to permanently delete your profile and
                release all reserved rooms?
              </p>
            </div>

            {/* Actions */}
            <div class="p-6 bg-base-200/30 flex gap-3">
              <button
                type="button"
                class="btn flex-1 font-bold uppercase"
                onClick={() => setIsOpen(false)}
              >
                Cancel
              </button>

              <button
                type="button"
                class="btn btn-error flex-1 font-black uppercase"
                onClick={() => formRef.current?.submit()}
              >
                Yes, Delete
              </button>
            </div>

            {/* Hidden Form */}
            <form
              ref={formRef}
              action="/profile/delete-account"
              method="post"
              class="hidden"
            />
          </div>
        </div>
      )}
    </>
  );
};
